export enum MenuItemType {
	Portal,
	Magazine,
}
